import { clsx } from "clsx";
import type { ChatLinkPreview } from "../types";

interface LinkPreviewCardProps {
  preview: ChatLinkPreview;
  mine: boolean;
}

export function LinkPreviewCard({ preview, mine }: LinkPreviewCardProps) {
  return (
    <a
      href={preview.url}
      target="_blank"
      rel="noreferrer"
      className={clsx(
        "mt-1 block overflow-hidden border text-left no-underline",
        mine
          ? "border-red-200 bg-white hover:bg-red-50"
          : "border-gray-200 bg-gray-50 hover:bg-gray-100",
      )}
    >
      {preview.image && (
        <img
          src={preview.image}
          alt=""
          className="w-full max-h-44 object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      )}
      <div className="px-2 py-1.5">
        {preview.site_name && (
          <div className="font-mono text-[10px] uppercase tracking-wider text-gray-500">
            {preview.site_name}
          </div>
        )}
        <div className="line-clamp-2 text-[12px] font-semibold leading-tight text-gray-900">
          {preview.title || preview.url}
        </div>
        {preview.description && (
          <div className="mt-0.5 line-clamp-2 text-[11px] leading-snug text-gray-600">
            {preview.description}
          </div>
        )}
      </div>
    </a>
  );
}
